<div class="dashboard-wrapper py-4 px-2 px-md-4 mb-2 mb-md-0">

    <section class="hero-banner p-4 p-md-5 rounded-4 mb-4 text-white position-relative overflow-hidden">
        <div class="position-relative z-2 max-w-xl">
            <div class="badge-secure d-inline-flex align-items-center gap-2 mb-3 px-3 py-2 rounded-pill">
                <i class="bi bi-shield-shaded"></i>Secure Verification Process
            </div>
            <h1 class="display-6 fw-bold mb-3 font-inter-bold">Verify Your Trading Partner</h1>
            <p class="opacity-80 mb-4 lh-base font-inter-light">
                Complete our simple 3-step verification process to verify your buyer or seller. This ensures secure and
                trustworthy transactions for all parties involved.
            </p>
            <button
                class="btn btn-action-start d-inline-flex align-items-center gap-2 text-white px-4 py-2.5 rounded-3 fw-semibold transition-all"
                (click)="startVerificationWorkflow()">
                <i class="bi bi-arrow-right small"></i> Start Verification 
            </button>
        </div>
    </section>

    <!-- <section class="row g-4 mb-5">
        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-blue-tint d-flex align-items-center justify-content-center text-primary">
                    <i class="bi bi-clock-fill fs-5"></i>
                </div>
                <div>
                    <h3 class="card-data fw-bold mb-0 lh-1">{{ stats.pending }}</h3>
                    <p class="card-text mb-2 mt-1 ">Pending Verifications</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-orange-tint d-flex align-items-center justify-content-center text-warning">
                    <i class="bi bi-hourglass-split fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">{{ stats.inReview }}</h3>
                    <p class="card-text mb-2 mt-1 ">In Review</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white px-3 py-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-green-tint d-flex align-items-center justify-content-center text-success">
                    <i class="bi bi-check-circle-fill fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">{{ stats.completed }}</h3>
                    <p class="card-text mb-2 mt-1 ">Completed this Month</p>
                </div>
            </div>
        </div>

        <div class="col-6 col-md-3">
            <div class="stat-card bg-white p-4 rounded-4 border shadow-sm d-flex align-items-top gap-2">
                <div
                    class="stat-icon-wrapper rounded-3 bg-purple-tint d-flex align-items-center justify-content-center text-purple">
                    <i class="bi bi-currency-dollar fs-5"></i>
                </div>
                <div>
                    <h3 class="fw-bold card-data mb-0 lh-1">${{ stats.spend | number }}</h3>
                    <p class="card-text mb-2 mt-1 ">Verification Spend</p>
                </div>
            </div>
        </div>
    </section> -->

    <section class="bg-white border rounded-4 shadow-sm overflow-hidden p-4">

        <div class="row g-3 align-items-center justify-content-between mb-4">
            <div class="col-12 col-md-7">
                <label class="form-label fw-semibold  text-header tracking-wide mb-1.5">Search Verifications</label>
                
                <div class="position-relative search-input-group">
                    <i class="bi bi-search search-icon position-absolute top-50 translate-middle-y text-muted"></i>
                    <input type="text" class="form-control ps-5" 
                    placeholder="Search by company name"
                    [ngModel]="pagination$.value.companyName"
                    (input)="onCompanyNameChange($any($event.target).value)" 
                     >
                
                </div>
            </div>

            <div class="col-12 col-md-5 d-flex gap-3 justify-content-md-end align-items-end">
                <div>
                    <label class="form-label text-header  fw-semibold tracking-wide mb-1.5">Status</label>
                    <select class="form-select filter-dropdown filter" [ngModel]="pagination$.value.status"
                        (ngModelChange)="onStatusChange($event)">
                        <option value="">All Statuses</option>
                        <option value="new">New</option>
                        <option value="validated">Validated </option>
                        <option value="mapped">Mapped </option>
                        <option value="sent">Sent</option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                    </select>
                </div>
                <div>
                    <label class="form-label text-header  fw-semibold tracking-wide mb-1.5">User Type</label>
                    <select class="form-select filter-dropdown filter" [ngModel]="pagination$.value.type"
                        (ngModelChange)="onUserTypeChange($event)">
                        <option value="">ALL</option>
                        <option value="seller">Seller</option>
                        <option value="buyer">Buyer</option>
                    </select>
                </div>
            </div>
        </div>

    </section>
    <section class="bg-white border rounded-4 shadow-sm overflow-hidden mt-4 mb-5  pb-5 pb-md-0">

        <header class="p-4">
            <h2 class="table-header mb-1 font-inter-bold fw-bold">Verification List</h2>
            <p class="sub-text small mb-0">Manage and track all seller verification requests</p>
        </header>
        @if (verificationList$ | async; as state){
        @if(state.loading){
        <div class="overlay">
            <div class="spinner-border"></div>
        </div>
        }
        @else if(state.error){
        <div>
            {{state.error}}
        </div>
        }
        @else if (state.data && state.data.length>0){
        <div class="table-responsive d-none d-md-block">
            <table class="table align-middle custom-dashboard-table mb-0">
                <thead>
                    <tr>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider  px-4 py-3">User
                            Name</th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Company</th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Date Submitted
                        </th>
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Status</th>
                        <!-- <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">Risk Rating
                        </th> -->
                        <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3">
                            Action</th>
                        <!-- <th scope="col" class="text-uppercase x-small text-secondary tracking-wider py-3 text-endpe">
                            Send for audit</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let record of state.data " class="table-row-hover">
                        <td class="py-3">
                            <div class="d-flex align-items-center gap-3">
                                <div
                                    class="avatar-circle rounded-circle bg-light d-flex align-items-center justify-content-center fw-semibold text-secondary overflow-hidden">
                                    {{ record.contactName.charAt(0) }}
                                </div>
                                <div>
                                    <div class="row-header fw-semibold text-wrap">{{ record.contactName }}</div>
                                    <div class="sub-row x-small mt-0.5">ID: #{{ record.id.slice(0,6)}}</div>
                                </div>
                            </div>
                        </td>

                        <td class="py-3">
                            <div class="text-dark row-header row-other">{{ record.companyName }}</div>
                            <div class="sub-row x-small mt-0.5">{{ record.country }}</div>
                        </td>

                        <td class="py-3">
                            <div class="text-dark row-header row-other">{{ record.dateCreated | date:'mediumDate'}}
                            </div>
                            <div class="sub-row  x-small mt-0.5">{{ record.daysAgo }}</div>
                        </td>

                        <td class="py-3">
                            @if (userType == 'admin') {
                            <select [ngModel]="record.status?.toUpperCase()" (ngModelChange)="onStatusUpdate(record, $event)"
                                class="form-select form-select-sm badge-status rounded-pill px-3 py-1.5 fw-semibold border-0"
                                [class.status-success]="record.status?.toUpperCase() === 'SUCCESS'"
                                [class.status-failed]="record.status?.toUpperCase() === 'FAILED'"
                                [class.status-new]="record.status?.toUpperCase() === 'NEW'"
                                [class.status-processing]="record.status?.toUpperCase() === 'SENT' || record.status?.toUpperCase() === 'VALIDATED' "
                                style="width: 140px; cursor: pointer; font-size: 0.75rem;">

                                <option value="NEW" class="bg-white text-dark">+ New</option>
                                 <option value="VALIDATED" class="bg-white text-dark">⏳ Validated</option>
                                <option value="SENT" class="bg-white text-dark"><i class="bi bi-send"></i> Sent</option>
                                <option disabled value="SUCCESS" class="bg-light text-dark">✅ Success</option>
                                <option value="FAILED" class="bg-light text-dark">❌ Failed</option>
                            </select>
                            } @else {
                            <span
                                class="badge-status rounded-pill p-2 text-nowrap d-inline-flex align-items-center gap-2"
                                [class.status-success]="record.status?.toUpperCase() === 'SUCCESS'"
                                [class.status-failed]="record.status?.toUpperCase() === 'FAILED'"
                                [class.status-new]="record.status?.toUpperCase() === 'NEW'"
                                [class.status-processing]="record.status?.toUpperCase() === 'VALIDATED' || record.status?.toUpperCase() === 'PROCESSING'">
                            @if (record.status) {
                            @switch (record.status.toUpperCase()) {
                            @case ('SUCCESS') {
                            <i class="bi bi-check-circle-fill"></i>
                            }
                            @case ('FAILED') {
                            <i class="bi bi-exclamation-circle-fill"></i>
                            }
                            @case ('VALIDATED') {
                            <i class="bi bi-hourglass-split"></i>
                            }
                            @default {
                            <i class="bi bi-plus-circle-fill"></i>
                            }
                            }
                            {{ record.status | titlecase }}
                            }
                            </span>
                            }
                        </td>

                        <!-- <td class="py-3">
                            <span
                                class="badge-risk rounded-pill px-2.5 py-1 text-nowrap d-inline-flex align-items-center gap-1.5"
                                [class.risk-low]="record.riskRating === 'Low Risk'"
                                [class.risk-medium]="record.riskRating === 'Medium Risk'"
                                [class.risk-high]="record.riskRating === 'High Risk'"
                                [class.risk-pending]="record.riskRating === 'Pending'">
                                <i class="bi" [class.bi-shield-check]="record.riskRating !== 'Pending'"
                                    [class.bi-dash]="record.riskRating === 'Pending'"></i>
                                {{ record.riskRating }}
                            </span>
                        </td> -->

                        <td class="py-3 ">
                            <div class="d-flex align-items-center justify-content-start gap-3">
                                <!-- <button
                                    class="btn btn-view-report btn-sm rounded-3 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                                    <i class="bi bi-eye-fill" style="color:#007AFF"></i> View Report
                                </button> -->
                                <!-- this button is disabled becuase first we need to send it for audit then only we can map the value  -->
                                <!-- <button (click)="mapCofanetForm(record)"
                                    class="btn btn-view-report btn-sm rounded-2 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                                     Map Canon Request
                                </button> -->
                                <!-- <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                                    (click)="downloadReport(record.id)">
                                    <i class="bi bi-download"></i>
                                </button> -->
                                @if(userType == 'admin'){
                                    <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                                        (click)="editVerificationForm(record)"
                                        data-bs-toggle="tooltip" 
                                        data-bs-placement="top" 
                                        title="Edit Record">
                                        <i class="bi bi-pencil-square"></i>
                                    </button>

                                      <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                                        (click)="createVerificationRecorForCompany(record)"
                                        data-bs-toggle="tooltip" 
                                        data-bs-placement="top" 
                                        title="Create New Company">
                                        <i class="bi bi-plus-circle-fill"></i>
                                    </button>

                                      <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                                        (click)="linkToExistingCompany(record)" 
                                        data-bs-toggle="tooltip" 
                                        data-bs-placement="top" 
                                        title="Link to Existing Company">
                                       <i class="bi bi-link-45deg"></i>
                                    </button>
                                }@else{
                                     <button
                                    class="btn btn-view-report btn-sm rounded-3 text-primary fw-semibold d-inline-flex align-items-center gap-1"
                                    (click)="editVerificationForm(record)">
                                    <i class="bi bi-eye-fill" style="color:#007AFF" ></i> View 
                                </button>
                                }
                               
                            </div>
                        </td>
                        <!-- <td class="py-3">
                            <input type="checkbox" class="form-check-input" id="termsCheckbox" [checked]="false"
                                (change)="onCheckboxToggle($event,record)">
                        </td> -->
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Mobile view: cards layout -->
        <div class="d-block d-md-none mobile-cards-container">
            <div *ngFor="let record of state.data" class="mobile-card p-3 border-bottom position-relative">
               
                <div class="d-flex align-items-start gap-3 mb-3  justify-content-between">
                    <div class="d-flex align-items-center gap-3 mb-3">
                          <div
                        class="avatar-circle rounded-circle bg-light d-flex align-items-center justify-content-center fw-semibold text-secondary overflow-hidden">
                        {{ record.contactName.charAt(0).toUpperCase() }}
                    </div>
                    <div>
                        <div class="fw-bold row-header text-dark font-inter-bold" style="font-size: 1.05rem;">
                            {{ record.contactName }}
                        </div>
                        <div class="sub-row x-small text-muted mt-0.5">ID: #{{ record.id.slice(0,6) }}</div>
                    </div>
                    </div>
                  
                    <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            (click)="editVerificationForm(record)">
                            <i class="bi bi-pencil-square"></i>
                    </button>
                </div>

                <!-- Info Grid -->
                <div class="card-info-grid mb-3">
                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Company</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.companyName }}, {{ record.country }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Date Submitted</span>
                        <span class="fw-semibold text-dark text-end small">{{ record.dateCreated | date:'mediumDate' }}</span>
                    </div>

                    <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Status</span>
                        @if (userType == 'admin') {
                        <select [ngModel]="(record.status || record.requestStatus)?.toUpperCase()" (ngModelChange)="onStatusUpdate(record, $event)"
                            class="form-select form-select-sm badge-status rounded-pill px-3 py-1.5 fw-semibold border-0 text-center"
                            [class.status-success]="(record.status || record.requestStatus)?.toUpperCase() === 'SUCCESS'"
                            [class.status-failed]="(record.status || record.requestStatus)?.toUpperCase() === 'FAILED'"
                            [class.status-new]="(record.status || record.requestStatus)?.toUpperCase() === 'NEW'"
                            [class.status-processing]="(record.status || record.requestStatus)?.toUpperCase() === 'PROCESSING' || (record.status || record.requestStatus)?.toUpperCase() === 'VALIDATED'"
                            style="width: 140px; cursor: pointer; font-size: 0.75rem;">

                            <option value="NEW" class="bg-white text-dark">+ New</option>
                            <option value="PROCESSING" class="bg-white text-dark">⏳ Processing</option>
                            <option disabled value="SUCCESS" class="bg-light text-dark">✅ Success</option>
                            <option value="FAILED" class="bg-light text-dark">❌ Failed</option>
                        </select>
                        } @else {
                        <span class="badge-status rounded-pill p-2 text-nowrap d-inline-flex align-items-center gap-2"
                            [class.status-success]="record.requestStatus === 'SUCCESS' || record.status?.toUpperCase() === 'SUCCESS'"
                            [class.status-failed]="record.requestStatus === 'FAILED' || record.status?.toUpperCase() === 'FAILED'"
                            [class.status-new]="record.requestStatus === 'NEW' || record.status?.toUpperCase() === 'NEW'"
                            [class.status-processing]="record.requestStatus === 'PROCESSING' || record.status?.toUpperCase() === 'VALIDATED' || record.status?.toUpperCase() === 'PROCESSING'">
                            @switch (record.requestStatus || record.status?.toUpperCase()) {
                                @case ('SUCCESS') {
                                    <i class="bi bi-check-circle-fill"></i> Completed
                                }
                                @case ('FAILED') {
                                    <i class="bi bi-exclamation-circle-fill"></i> Failed
                                }
                                @case ('PROCESSING') {
                                    <i class="bi bi-hourglass-split"></i> In Review
                                }
                                @case ('VALIDATED') {
                                    <i class="bi bi-hourglass-split"></i> In Review
                                }
                                @default {
                                    <i class="bi bi-clock-fill"></i> Pending
                                }
                            }
                        </span>
                        }
                    </div>

                    <!-- <div class="d-flex justify-content-between align-items-center py-2 border-bottom border-light">
                        <span class="text-muted small">Risk Rating</span>
                        <span class="badge-risk rounded-pill px-2.5 py-1 text-nowrap d-inline-flex align-items-center gap-1.5"
                            [class.risk-low]="(record.riskRating || 'Pending') === 'Low Risk'"
                            [class.risk-medium]="(record.riskRating || 'Pending') === 'Medium Risk'"
                            [class.risk-high]="(record.riskRating || 'Pending') === 'High Risk'"
                            [class.risk-pending]="(record.riskRating || 'Pending') === 'Pending'">
                            <i class="bi" 
                                [class.bi-shield-check]="(record.riskRating || 'Pending') === 'Low Risk'"
                                [class.bi-exclamation-triangle-fill]="(record.riskRating || 'Pending') === 'Medium Risk'"
                                [class.bi-exclamation-octagon-fill]="(record.riskRating || 'Pending') === 'High Risk'"
                                [class.bi-dash]="(record.riskRating || 'Pending') === 'Pending'"></i>
                            {{ record.riskRating || 'Pending' }}
                        </span>
                    </div> -->
                </div>

                <!-- Actions Row -->
                <div class="d-flex align-items-center justify-content-between mt-3">
                    <!-- <button class="btn btn-view-report btn-sm rounded-3 text-primary fw-semibold d-inline-flex align-items-center gap-1">
                        <i class="bi bi-eye-fill" style="color:#007AFF"></i> View Report
                    </button> -->
                    <div class="d-flex gap-3">
                        <!-- <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            [class.opacity-25]="record.requestStatus === 'NEW'"
                            [disabled]="record.requestStatus === 'NEW'"
                            (click)="downloadReport(record.id)">
                            <i class="bi bi-download"></i>
                        </button> -->
                        <!-- <button class="btn btn-icon-download p-1 border-0 bg-transparent text-secondary"
                            (click)="editVerificationForm(record.id)">
                            <i class="bi bi-pencil-square"></i>
                        </button> -->
                    </div>
                </div>
            </div>
        </div>

        <footer class="d-flex flex-column flex-md-row align-items-center justify-content-between p-4 mt-2 pb-5">
            <div class="text-muted small mb-3 mb-md-0">
                <!-- Showing <b>{{currentPage * pageSize + 1}} to {{(currentPage + 1) * pageSize > totalRecords ? totalRecords : (currentPage + 1) * pageSize}}</b> of {{totalRecords}} orders -->
                Showing <span class="fw-semibold text-dark">{{start}}</span> to {{end}} of <span
                    class="fw-semibold text-dark">{{totalRecords}} results</span>

            </div>
            <nav aria-label="Page navigation dashboard items">
                <ul class="pagination pagination-sm mb-0 gap-2">

                   
                    <li class="page-item" [class.disabled]="currentPage === 0">
                        <button class="page-link rounded-2 border px-3" (click)="onPageChange((+currentPage) - 1)">
                            Previous
                        </button>
                    </li>

                    @for(pageNum of pages; track pageNum){
                    <li class="page-item" [class.active]="currentPage === pageNum">
                        <button class="page-link rounded-2 border" (click)="onPageChange(pageNum)">
                            {{ pageNum + 1 }}
                        </button>
                    </li>
                    }

                   
                    <li class="page-item" [class.disabled]="currentPage === (totalPages - 1)">
                        <button class="page-link rounded-2 border px-3" (click)="onPageChange((+currentPage) + 1)">
                            Next
                        </button>
                    </li>

                </ul>
            </nav>
        </footer>
        }
        }
    </section>
</div>